import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from "@mui/icons-material/Add";
import TextField from '@mui/material/TextField';
import Stack from "@mui/material/Stack";
import { AddCategoryTech } from '../../../services/projects.handlers';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 3,
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function AddTechCategory(props) {
  const [open, setOpen] = React.useState(false)
  const [formData, setFormData] = React.useState({ id: null, text: "" })
  const [errorData, setErrorData] = React.useState({
    error: false,
    errorText: ""
  })
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorData({
      error: false,
      errorText: ""
    })
    const data = new FormData(event.currentTarget);
    if (data.get("techCategory")) {
      if (formData.id == null) {
        AddCategoryTech({ name: data.get("techCategory") }).then((response) => {
          if (response.status) {
            props.apiCall()
            handleClose()
            alert(response.data.message)
            setFormData({ id: null, text: "" })
          }
        })
      } else {

      }
    } else {
      setErrorData({
        error: true,
        errorText: "Field is required"
      })
    }

  }

  return (
    <div>
      <Button
        onClick={handleOpen}
        variant="contained"
      >
        <AddIcon /> Add Tech Category
        </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        // onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} component="form"
            onSubmit={handleSubmit}>
            <Typography id="transition-modal-title" variant="h6" component="h2" style={{ marginBottom: "20px" }}>
              Tech Category
            </Typography>
            <TextField
              error={errorData.error}
              helperText={errorData.errorText}
              value={formData.text}
              onChange={(e) => setFormData({ ...formData, text: e.target.value })}
              required
              fullWidth
              name="techCategory"
              id="tech-category"
              label="Tech Category"
              variant="outlined" />
            <Stack
              spacing={2}
              direction="row"
              style={{ marginTop: "20px", justifyContent: "flex-end" }}
            >
              <Button
                type="submit"
                variant="contained"
              >
                Add
                </Button>
              <Button
                onClick={handleClose}
                style={{ backgroundColor: "grey" }}
                variant="contained"
              >
                Close
                </Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
